import cn from 'classnames';
import { Link } from 'src/navigation';
import styles from './nav-link.module.scss';
import type { ComponentProps } from 'react';

const NavLink = ({ text, href, className, ...props }: NavLinkProps) => {
	return (
		<Link
			prefetch={false}
			className={cn('button', 'tertiary', styles.link, className)}
			href={href}
			{...props}
		>
			{text}
		</Link>
	);
};

export { NavLink };

interface NavLinkProps extends ComponentProps<typeof Link> {
	text: string;
	className?: string;
}
